import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { List } from 'immutable';
import { Field, FieldArray } from 'redux-form/immutable';

import TimeplanField from '../../../../app/components/Form/Timeplan/TimeplanField';
import Comments from './Comments';
import MileageAllowences from './MileageAllowences';
import { useTranslation } from 'react-i18next';

function TimeReporting({ dates, form, timeplanUnits }) {
  const { t } = useTranslation();
  return (
    <div>
      <Field
        name="timeplanUnits"
        component={TimeplanField}
        dates={dates}
        resources={new List()}
        showWeekHeader={false}
        strictDates
        version={2}
        noPanel
        compareTimeplanUnits={timeplanUnits}
        public
      />
      <FieldArray
        name="mileageAllowances"
        component={MileageAllowences}
        form={form}
      />
      <FieldArray
        name="comments"
        component={Comments}
        form={form}
      />
    </div>
  );
}

TimeReporting.propTypes = {
  dates: PropTypes.instanceOf(List).isRequired,
  form: PropTypes.string.isRequired,
};

export default compose()(TimeReporting);
